import ReactJson from "react-json-view";
import SimpleTable from "../../../shared/SimpleTable";
import EmployeeStopLoss from "../../../javelina/EmployeeStopLoss";
import { asJvArray } from "./StopLossContractDetail";

const Employee = ({ data }) => {
    const members = asJvArray(data?.details?.Response?.Member);

    return (
        <div>
            {members.map((member, i) => {
                return (
                    <div key={`${i}-employee`}>

                        {member?.EmployeeMaintenance && <div>
                            <p className="sub-title">{member?.EmployeeMaintenance?.CertificateNumber}</p>
                            <p className="title">{`${member?.EmployeeMaintenance?.FirstName} ${member?.EmployeeMaintenance?.MiddleName} ${member?.EmployeeMaintenance?.LastName}`}</p>
                            <p>EmployeeID: {member?.EmployeeMaintenance?.EmployeeID}</p>
                        </div>}

                        {member?.DependentMaintenance && <div>

                            <p className="sub-title">{member?.DependentMaintenance?.CertificateNumber}</p>
                            <p className="title">{`${member?.DependentMaintenance?.DepFirstName} ${member?.DependentMaintenance?.DepMiddleName} ${member?.DependentMaintenance?.DepLastName}`}</p>
                            <p>EmployeeID: {member?.DependentMaintenance?.EmployeeID}</p>
                            <p>DependentID: {member?.DependentMaintenance?.DependentID}</p>
                            <p>DepSequenceNumber: {member?.DependentMaintenance?.DepSequenceNumber}</p>
                            <p>RelationToEmpDescription: {member?.DependentMaintenance?.RelationToEmpDescription}</p>
                        </div>}

                        <div style={{ padding: '1rem 0' }}>
                            <p style={{ fontWeight: 600, fontSize: '1.1rem', paddingBottom: '.6rem' }}>Stop Loss</p>
                            <EmployeeStopLoss member={member} searchRow={data} />
                        </div>


                        <ReactJson
                            style={{ padding: "1rem" }}
                            src={member}
                            name={false}
                            collapsed={1}
                            collapseStringsAfterLength={150}
                            displayDataTypes={false}
                            displayObjectSize={false}
                            sortKeys={false}
                        />

                        {member.EmployeeCoverages?.EmpCoverageEffectiveDateRecord && (
                            <>
                                <p style={{ fontWeight: 600, fontSize: "1rem", padding: "1rem 0rem" }}>Coverages</p>

                                <SimpleTable
                                    columns={[
                                        { label: "Medical", attribute: "EmployeeEligibilityCoverage.EmployeeMedicalCoverage.BenefitPlan" },
                                        { label: "M Level", attribute: "EmployeeEligibilityCoverage.EmployeeMedicalCoverage.CoverageLevel" },

                                        { label: "Prescription", attribute: "EmployeeEligibilityCoverage.EmployeePrescriptionCoverage.BenefitPlan" },
                                        { label: "P Level", attribute: "EmployeeEligibilityCoverage.EmployeeMedicalCoverage.CoverageLevel" },


                                        { label: "Location", attribute: "Location" },
                                        { label: "Department", attribute: "Department" },

                                        { label: "Status", attribute: "Status" },
                                        { label: "EffectiveDate", attribute: "EffectiveDate" },
                                        { label: "TerminationDate", attribute: "LocatTerminationDateion" },
                                    ]}
                                    disableHeaderFormatting={true}
                                    rows={member.EmployeeCoverages?.EmpCoverageEffectiveDateRecord}
                                />

                            </>
                        )}


                        {member.DependentCoverages?.DependentEligibilityCoverage && (
                            <>
                                <p style={{ fontWeight: 600, fontSize: "1rem", padding: "1rem 0rem" }}>Coverages</p>

                                <SimpleTable
                                    columns={[
                                        { label: "Medical", attribute: "DependentMedicalCoverage.BenefitPlan" },
                                        { label: "Medical", attribute: "DependentMedicalCoverage.EmployeeBenefitPlan" },
                                        { label: "M Level", attribute: "DependentMedicalCoverage.CoverageLevel" },

                                        { label: "Prescription", attribute: "DependentPrescriptionCoverage.BenefitPlan" },
                                        { label: "Prescription", attribute: "DependentPrescriptionCoverage.EmployeeBenefitPlan" },
                                        { label: "P Level", attribute: "DependentPrescriptionCoverage.CoverageLevel" },




                                        { label: "Status", attribute: "Status" },
                                        { label: "EffectiveDate", attribute: "EffectiveDate" },
                                        { label: "TerminationDate", attribute: "LocatTerminationDateion" },
                                        { label: "TerminationReason", attribute: "TerminationReason" },


                                    ]}
                                    disableHeaderFormatting={true}
                                    rows={member.DependentCoverages?.DependentEligibilityCoverage}
                                />

                            </>
                        )}

                    </div>
                );
            })}
        </div>
    );
};

export default Employee;
